// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__A8KgS","additionalInfo":"AgreementModal_additionalInfo__1mFKe"};